import { Checkbox, FormField, Switch, UIText1, UIText3, useDeviceType } from '@cian/ui-kit';
import { NBSP } from 'shared/common/constants';

import { EFieldName } from 'shared/mortgageMiniCalculator/constants/enum';
import styles from './styles.css';

const INSURANCE_DESCRIPTION_TEXT = `Не обязательно, но банк повысит ставку при отказе от${NBSP}страховки`;

interface IInsuranceFieldProps {
  lifeInsurance: boolean;
  onChange: (value: boolean) => void;
}

const InsuranceFieldMobile: React.FC<IInsuranceFieldProps> = ({ lifeInsurance, onChange }) => {
  return (
    <div className={styles.header}>
      <div className={styles.text}>
        <UIText1>Страхование{NBSP}жизни</UIText1>
        <div className={styles.description}>
          <UIText3 color="text-secondary-default">{INSURANCE_DESCRIPTION_TEXT}</UIText3>
        </div>
      </div>
      <Switch
        name={EFieldName.lifeInsurance}
        checked={lifeInsurance}
        onChange={(_, value: boolean) => onChange(value)}
      />
    </div>
  );
};

const InsuranceFieldDesktop: React.FC<IInsuranceFieldProps> = ({ lifeInsurance, onChange }) => {
  return (
    <div className={styles.root}>
      <Checkbox
        name={EFieldName.lifeInsurance}
        checked={lifeInsurance}
        onChange={(_, value: boolean) => onChange(value)}
        label={<>Страхование{NBSP}жизни</>}
      />
      <div className={styles['desktop-description']}>
        <UIText3 color="text-secondary-default">{INSURANCE_DESCRIPTION_TEXT}</UIText3>
      </div>
    </div>
  );
};

export const InsuranceField: React.FC<IInsuranceFieldProps> = ({ lifeInsurance, onChange }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const InsuranceFieldComponent = isDesktop ? InsuranceFieldDesktop : InsuranceFieldMobile;

  return (
    <FormField dataTestId={`field-${EFieldName.lifeInsurance}`} withoutMargin>
      <InsuranceFieldComponent lifeInsurance={lifeInsurance} onChange={onChange} />
    </FormField>
  );
};
